var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"syxz"},[_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("验货须知")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.msg)}})])}
var staticRenderFns = []

export { render, staticRenderFns }